export default {"src":"/_next/static/media/shieldWithCheckmark_64.a6e678fb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};